import { Archive, ArrowRight, Star } from "phosphor-react";
import React from "react";
import { Link } from "react-router-dom";

const Card = ({ data }) => {
  return (
    <>
      <Link to={`/${data.id}`}>
        <div className="transition-all duration-200 ease-in-out border border-slate-50 hover:shadow-2xl hover:-translate-y-3 p-4 rounded-3xl bg-white">
          <div className="relative mb-6">
            <div className="absolute bottom-0 right-0 w-full">
              <div className="p-10 bg-white/50 backdrop-blur-lg z-20 rounded-b-2xl">
                <h1 className="text-xl lg:text-3xl text-slate-900 font-bold mb-1">
                  {data.title}
                </h1>
                <div className="flex space-x-4 items-center">
                  <p className="flex text-sm py-1 px-2 bg-green-500 rounded-full text-slate-900 font-medium">
                    {data.genres[0]}
                  </p>
                  <div className="h-[6px] w-[6px] rounded-full bg-slate-600"></div>
                  <p className="text-lg lg:text-xl text-slate-600 font-medium">
                    {data.year}
                  </p>
                </div>
              </div>
            </div>
            <img
              className="rounded-2xl object-cover h-[450px] w-full"
              src={data.poster}
              alt=""
            />
            <div className="flex space-x-3 items-center absolute top-4 right-4 bg-white/50 backdrop-blur-md py-3 px-6 rounded-xl">
              <span className="text-lg lg:text-2xl font-semibold text-slate-700">
                {data.imdb_rating}
              </span>
              <Star className="text-yellow-500" size={24} weight="fill" />
            </div>
          </div>

          <div className="flex">
            <div className="flex w-full justify-between space-x-3 items-center">
              <div className="flex space-x-3 items-center">
                <div className="flex rounded-xl p-4 bg-slate-100">
                  <Archive weight="fill" className="text-slate-400" size={24} />
                </div>
                <div>
                  <p className="text-lg font-medium">2 Rooms</p>
                  <p className="text-sm font-normal text-slate-500">Channels</p>
                </div>
              </div>
              <button className="p-3 text-white transition-all duration-200 ease-in-out hover:scale-110 rounded-full bg-sky-500">
                <ArrowRight size={24} />
              </button>
            </div>
            <div></div>
          </div>
        </div>
      </Link>
    </>
  );
};

export default Card;
